import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (
    accessToken: string, 
    data: {
        reportFiltersetUid: string | null;
    }
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        },        
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.prefilteredReports?.prefilteredBaselineReport?.currentAnnualEndUseChart.error)
            throw new Error(
                data.prefilteredReports.prefilteredBaselineReport.currentAnnualEndUseChart.error
            );
        return (
            (data.prefilteredReports?.prefilteredBaselineReport
                ?.currentAnnualEndUseChart as CurrentAnnualEndUseChart) || null
        );
    });

const query = graphql(`
    query currentAnnualEndUseChart($reportFiltersetUid: Uuid) {
        prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
            prefilteredBaselineReport {
                currentAnnualEndUseChart {
                    error
                    carbonEmissions {
                        endUse
                        fuelType
                        value
                    }
                    energyConsumption {
                        endUse
                        fuelType
                        value
                    }
                    utilityCost {
                        endUse
                        fuelType
                        value
                    }
                }
            }
        }
    }
`);

export default queryFn;
